import { render, staticRenderFns } from "./linkCustomerAcquisition.vue?vue&type=template&id=8e367bf4&scoped=true"
import script from "./linkCustomerAcquisition.vue?vue&type=script&lang=js"
export * from "./linkCustomerAcquisition.vue?vue&type=script&lang=js"
import style0 from "./linkCustomerAcquisition.vue?vue&type=style&index=0&id=8e367bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e367bf4",
  null
  
)

export default component.exports